import axios, { AxiosResponse } from 'axios';
import { TResetPasswordReq } from '@src/types';

export const requestResetPasswordAdmin = (
  email: string
): Promise<AxiosResponse<string>> => {
  return axios.post('/admin/auth/request-reset-password', {
    email: email.toLowerCase(),
  });
};

export const verifyOtp = (
  otp: string,
  email: string
): Promise<AxiosResponse<{ reset_token: string }>> => {
  return axios.post('/admin/auth/verify-otp', {
    otp,
    email: email.toLowerCase(),
  });
};

export const adminResetPassword = (
  data: TResetPasswordReq
): Promise<AxiosResponse<string>> => {
  return axios.post('/admin/auth/reset-password/complete', data);
};
